/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './fetchLabels.defs.js'
export { main as default } from './fetchLabels.defs.js'
